import { Controller } from "@hotwired/stimulus";
import ToastService from "../../shared/toast_service";

/**
 * Clipboard Controller
 *
 * Handles copying text to clipboard with visual feedback
 *
 * @example
 * ```ruby
 * button data: {
 *   controller: "clipboard",
 *   clipboard_text_value: "Text to copy",
 *   action: "click->clipboard#copy"
 * }
 * ```
 */
export default class extends Controller {
  static values = {
    text: String,
    successMessage: {
      type: String,
      default: "Copied to clipboard"
    }
  };

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      new ToastService().success({
        text: this.successMessageValue
      });
    });
  }
}